"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.subscribeByEmailApiToken = void 0;
var Api_1 = require("@/api/remote/Api");
exports.subscribeByEmailApiToken = function (email, languageCode, token) {
    return Api_1.api().request({
        method: 'POST',
        url: languageCode + "/api/communication/subscribebyemail",
        headers: {
            'X-XSRF-TOKEN': token,
        },
        data: {
            email: email
        },
    });
};
